<template>
    <div class="downloads" v-wechat-title="$route.meta.title">
        <div class="header">
            <h1 class="title">下载专区</h1>
            <p class="tip">集合蓝鲸各类资源包，含官方套餐，完整包，工具包，证书下载等</p>
        </div>
        <div class="tab">
            <ul class="tab-list">
                <li :class="['tab-item', activeTab === tab.key ? 'active' : '']" v-for="tab in tabList" :key="tab.key" @click="changeTab(tab.key)">{{tab.name}}</li>
            </ul>
        </div>
        <div class="content" v-loading="loading">
            <downloadContent
                :loading="loading"
                :item="tabData"
                :active-tab="activeTab"
                @recordUserDownload="recordUserDownload"
                @containerDeployValidate="containerDeployValidate">
            </downloadContent>
        </div>
    </div>
</template>

<script>
import downloadContent from './downloadContent.vue'
export default {
    name: 'downloads',
    components: {
        downloadContent
    },
    props: {
    },
    data () {
        return {
            loading: false,
            activeTab: 'packageDown',
            downloadPageInfo: [],
            tabData: {},
            tabList: [
                { name: '套餐下载', key: 'packageDown'},
                { name: '证书下载', key: 'certificate'},
                { name: '版本列表', key: 'versionList'},
                { name: '工具', key: 'tool'}
            ]
        }
    },
    computed: {
        isLogin () {
            return this.$store.state.isLogin
        },
        userInfo () {
            return this.$store.state.userInfo
        }
    },
    watch: {
        activeTab: {
            handler (val) {
                this.getDownloadList()
            },
            immediate: true
        }
    },
    async created () {
        await this.getDownloadList()
        this.activeTab = this.$route.query.type || 'packageDown'
        this.changeTab(this.activeTab)
    },
    methods: {
        async getDownloadList () {
            this.loading = true
            await axios.get(myUrl + 'page/layer/download_page/info/').then(res => {
                res.data.data.children.forEach(item => {
                    const curTab = this.tabList.find(tab => tab.name === item.name)
                    item.key = curTab.key
                })
                this.downloadPageInfo = res.data.data.children
            })
            this.loading = false

        },
        changeTab (type) {
            const tabData = this.downloadPageInfo.find(s => s.key === type)
            if (type === 'certificate' || type === 'tool') {
                window.open(tabData.url, '_self')
                return
            }
            this.tabData = tabData
            this.activeTab = type
            this.$router.push({
                path: '/s-mart/downloads',
                query: {
                    type,
                    version: 'containerize'
                }
            })
        },
        // 记录用户下载 params MD5
        recordUserDownload (cur) {
            const params = {
                name: cur.extra_info.pkg_name_version
            }
            axios.post(myUrl + 'core/product/download_record/', params).then(res => {
                if (res.status === 200) {
                    this.getWhaleCoin()
                    window.open(cur.url,"_blank")
                }
            }).catch(error => {
                if (error.status === 402) {
                    this.$emit('openInformationPopup', cur.url)
                }
            })

        },
        async getWhaleCoin () {
            try {
              await axios.post(myUrl + 'trade/whalecoin/package_download/', {
                package_id: '1',
                qq: this.userInfo.qq
              })  
            } catch (error) {
                console.warn(error);
            }
        },
        // 容器部署校验登录，完善信息
        containerDeployValidate (cur) {
            if (!this.isLogin) {
                axios.post(myUrl + "login/get_user_info/")
                return
            }
            const needFields = ['company', 'nick_name', 'qq', 'server_node'].map(field => this.userInfo[field]).every(field => field)
            if (!needFields) {
                this.$emit('openInformationPopup', cur.url)
                return
            }
            this.getWhaleCoin()
            window.open(cur.url, '_blank')
        }
        
    }
}
</script>
<style lang="scss">
    .bk-content {
        // background-color: #fff;
    }
</style>
<style lang="scss" scoped>
    .downloads {
        margin-top: 60px;
        // background-color: #fff;
        display: flex;
        flex-direction: column;
        .header {
            width: 100%;
            height: 200px;
            background: url('../../images/downloads/downloadsbg.png');
            display: flex;
            flex-direction: column;
            align-items: center;
            .title {
                margin: 56px 0 19px ;
                width: 112px;
                height: 37px;
                font-family: MicrosoftYaHei-Bold;
                font-weight: Bold;
                font-size: 28px;
                color: #FFFFFF;
            }
            .tip {
                width: 464px;
                height: 21px;
                font-family: MicrosoftYaHei;
                font-size: 16px;
                color: #FFFFFF;
            }
        }
        .tab {
            height: 54px;
            background: #FFFFFF;
            box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10);
            .tab-list {
                display: flex;
                justify-content: space-between;
                width: 522px;
                height: 54px;
                line-height: 54px;
                margin: 0 auto;
                .tab-item {
                    cursor: pointer;
                    width: 97px;
                    height: 100%;
                    text-align: center;
                    width: 490px;
                    height: 54px;
                    font-family: MicrosoftYaHei;
                    font-size: 16px;
                    border-bottom: 2px solid #fff;
                    margin: 0 15px;
                    &:hover {
                        color: #3A84FF;
                    }
                }
                .active {
                    color: #3A84FF;
                    border-bottom: 2px solid #3A84FF;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// index.vue?8d296942